import { FunctionComponent } from 'react';
import { SharedIconInfo } from '../../icons/shared-icon-info';
import { Tooltip, Box, IconButton, Text } from '@chakra-ui/react';

interface AppToolTipProps {
  text: string;
  closeDelay?: number;
}

export const AppToolTip: FunctionComponent<AppToolTipProps> = ({ text, closeDelay }) => {
  return (
    <Box display={'inline'}>
      <Tooltip
        maxW={{ base: '100vw', md: '50vw' }}
        p={4}
        closeDelay={closeDelay ? closeDelay : 0}
        hasArrow
        label={
          <Box>
            <Text dangerouslySetInnerHTML={{ __html: text }}></Text>
          </Box>
        }
        fontSize="md"
        placement="top">
        <IconButton
          tabIndex={-1}
          bgColor={'transparent'}
          _hover={{ bgColor: 'gray.100' }}
          mb={1}
          w={`fit`}
          p={0}
          icon={<SharedIconInfo color={`blue.500`} boxSize={8} />}
          aria-label="meer informatie"></IconButton>
      </Tooltip>
    </Box>
  );
};
